<template>
  <div class="medical-visit">
    <div class="patient_list">
        <div class="checkin-btn">
          <van-button type="primary" round color="#0AA8AF" @click="addVisit()" block>新增拜访</van-button>
        </div>
        <van-list v-model="loading" :finished="finished" @load="onLoad" >
            <van-cell-group inset class="cell-group" v-for="item,index in list" :key="index">
                <van-cell  :border="false">
                    <template #title><div class="grey_label">省份城市:</div></template>   
                    <div>{{item.province}}{{item.city}}</div>
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">医院名称:</div></template>      
                    <div>{{item.hospital_name}}</div> 
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">医生姓名:</div></template>      
                    <div>{{item.doctor_name}}</div> 
                </van-cell>
                <van-cell  :border="false">
                    <template #title><div class="grey_label">拜访日期:</div></template>      
                    <div>{{item.vist_date}}</div> 
                </van-cell>
                <div class="detail_btn" @click="showDetail(item)">查看详情<van-icon color="#9D9D9D" name="arrow" /></div>
            </van-cell-group>

            <template #finished>
                <van-divider :style="{ color: '#bababa', borderColor: '#bababa', padding: '0 80px'}">
                    <div style="width:3px;height:3px;border-radius:100%;background-color:#bababa;"></div>
                </van-divider>
            </template>
        </van-list>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { List } from 'vant';
import { Divider } from 'vant';
import { mapState } from 'vuex';
import { getDoctorVistList } from '@/api/publicWelfareStaff';
// import { mapMutations } from "vuex";
Vue.use(Divider);
Vue.use(List);
export default {
    data(){
        return {
          searchValue: '',
            
            //无限加载列表
            list: [],
            loading: false,
            finished: false,
            page:1,
        }
    },
    computed: {
      ...mapState(['publicWelfareStaff'])
    },
    created() {
      console.log("publicWelfareStaff",this.publicWelfareStaff)
    },
    methods: {
      //   ...mapMutations(['setOriginRoute']),
      async fetchData(page) {
        let DATA
        let sendData = {
          page: page,
          volunteer_id:this.publicWelfareStaff.checkin_info.papid,
          service:1
        }
        await getDoctorVistList(sendData).then(res => {
          console.log("医护拜访列表：",res)
          this.list=[...this.list,...res.data]
          DATA = res.data
        }).catch(err => {
          Toast(err.response.data.message)
        })
        return DATA
      },
      async onLoad() {
        // 异步更新数据        
            await this.fetchData(this.page).then(res => {
              console.log("fetchData",res)
              if (res.length>0) this.page++

              // 加载状态结束
              this.loading = false;

              // 数据全部加载完成
              if (res.length==0) {
                  this.finished = true;
              }
            })
      },
      addVisit(item){
        // 新增/修改记录
        console.log(item?"修改记录":"新增记录")
        const title = item?"更新患者服务":"新增医护拜访"
        //存储返回的路径名
        this.$store.commit("setOriginRoute", this.$route.name);

        this.$router.push({name:'addVisit',query:{'title':title}})
      },
      showDetail(item) {
        // 查看详细
        console.log("查看详细")
        // this.$store.commit('setDoctor_visit_item',item)
        this.$router.push({
          name:"medicalVisitDetail",
          query:{
            doctor_vist_id: item.id
          }
        })
      }
    }
}
</script>

<style lang="scss" scoped>
.medical-visit{
    min-height: 100vh;
    background-color: #F9F9F9 ;
    font-size: 16px;
    ::v-deep .grey_label{
        color:#9D9D9D;
        white-space:nowrap;
    }
    .van-search{
        padding:16px;
    }
    .van-cell-group {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    .patient_list{
      box-shadow: 0 -2px 6px rgba(73, 46, 46, 0.2);
      padding-bottom: 44px;
        .checkin-btn {
            padding: 25px;
        }
        .cell-group{
            margin-bottom:10px;
            .detail_btn{
              text-align: right;
              color: #0A0A0A;
              padding-right: 15px;
              padding-bottom: 20px;
              font-size: 15px;
            }
            .van-cell__title {
                flex: 1;
                text-align: right;
                margin-right: 10px;
            }
            .van-cell__value{
                flex: 3;
                color:#0A0A0A;
                white-space:nowrap;
                text-align: left;
                // display:flex;
                // justify-content:flex-start;
                // align-items:center;
            .alignment-flex{
                display:flex;
                justify-content:flex-start;
                align-items:flex-start;
            }
            }
        }
      
    }
}
</style>